// store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import categoryReducer from './categorySlice';
import orderReducer from './orderSlice';
import restaurantPublicInfo from './restaurantPublicInfo';

export default configureStore({
  reducer: {
    user: userReducer,
    category: categoryReducer,
    order: orderReducer,
    restaurantPublicInfo: restaurantPublicInfo,
  },
});
